import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a02b0d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "アプリ設定", -1))
const _hoisted_3 = { class: "dialog-form-area settings" }
const _hoisted_4 = { class: "dialog-form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "駒画像", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "dialog-form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "盤画像", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "dialog-form-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "駒音の大きさ", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "%", -1))
const _hoisted_16 = { class: "dialog-form-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "時計音の大きさ", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "%", -1))
const _hoisted_20 = { class: "dialog-form-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "時計音の高さ", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "Hz (220 ~ 880)", -1))
const _hoisted_24 = { class: "dialog-form-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "時計音の対象", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "全ての手番", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "onlyUser" }, "人の手番のみ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "dialog-form-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label-wide" }, "改行文字", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "crlf" }, "CR + LF (Windows)", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "lf" }, "LF (UNIX/Mac)", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cr" }, "CR (90年代Mac)", -1))
const _hoisted_36 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("select", {
            ref: "pieceImage",
            value: _ctx.appSetting.pieceImage
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieceImageTypes, (pieceImageType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: pieceImageType,
                value: pieceImageType.value
              }, _toDisplayString(pieceImageType.name), 9, _hoisted_7))
            }), 128))
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("select", {
            ref: "boardImage",
            value: _ctx.appSetting.boardImage
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardImageTypes, (boardImageType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: boardImageType,
                value: boardImageType.value
              }, _toDisplayString(boardImageType.name), 9, _hoisted_11))
            }), 128))
          ], 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("input", {
            ref: "pieceVolume",
            value: _ctx.appSetting.pieceVolume,
            type: "number",
            max: "100",
            min: "0"
          }, null, 8, _hoisted_14),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("input", {
            ref: "clockVolume",
            value: _ctx.appSetting.clockVolume,
            type: "number",
            max: "100",
            min: "0"
          }, null, 8, _hoisted_18),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("input", {
            ref: "clockPitch",
            value: _ctx.appSetting.clockPitch,
            type: "number",
            max: "880",
            min: "220"
          }, null, 8, _hoisted_22),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("select", {
            ref: "clockSoundTarget",
            value: _ctx.appSetting.clockSoundTarget
          }, _hoisted_29, 8, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("select", {
            ref: "returnCode",
            value: _ctx.appSetting.returnCode
          }, _hoisted_36, 8, _hoisted_32)
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveAndClose()))
        }, " 保存して閉じる "),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}